module.exports = __webpack_public_path__ + "static/media/R1.cf542748.svg";